export class AuthV2VerifySoftwareTokenResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "session",
            "baseName": "session",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2VerifySoftwareTokenResponse.attributeTypeMap;
    }
    constructor() {
    }
}
